import React from 'react';
import ReactDOMClient from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import * as Sentry from '@sentry/react';

import App from './App';
import store from '../redux';
import { LiveStreamConnector } from './LiveStreamConnector';

import 'firebase-service/firebase-client';

if (process.env.MODE !== 'local') {
  Sentry.init({
    dsn: 'https://0e97762a2b3d631298cbe8a4fc7eaa64@o969560.ingest.us.sentry.io/4506887298351104',
    integrations: [Sentry.browserTracingIntegration()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: process.env.MODE === 'prod' || process.env.MODE === 'dev' ? 0.2 : 1.0,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/ynet-audiochat-prod.firebaseapp\.com\/api/,
      /^https:\/\/admin-ynet-audiochat-prod.firebaseapp\.com\/api/,
      /^https:\/\/ynet-audiochat-dev.firebaseapp\.com\/api/,
      /^https:\/\/admin-ynet-audiochat-dev.firebaseapp\.com\/api/,
    ],
    // Session Replay
    // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysSessionSampleRate: process.env.MODE === 'prod' || process.env.MODE === 'dev' ? 0.2 : 1.0,
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    environment: process.env.MODE,
  });
}

const Wrap = (
  <HelmetProvider>
    <Provider store={store}>
      <LiveStreamConnector>
        <Router>
          {/* <React.StrictMode> */}
          <App />
          {/* </React.StrictMode> */}
        </Router>
      </LiveStreamConnector>
    </Provider>
  </HelmetProvider>
);

const container = document.getElementById('root');
if (container) ReactDOMClient.hydrateRoot(container, Wrap);
